/* SK Collection Grid - Cargar mas + anadir al carrito */
(function () {
  'use strict';

  /* Mover los agotados al final del grid, preservando su orden relativo.
     Idempotente: appendChild sobre un hijo existente lo reubica al final.
     Necesario tras 'cargar mas': la pagina nueva (disponibles) entra despues
     de los agotados de la pagina previa, asi que hay que re-hundirlos. */
  function sinkSoldOut(grid) {
    if (!grid) return;
    var sold = grid.querySelectorAll('.sk-collection-grid__card--sold-out');
    for (var i = 0; i < sold.length; i++) {
      grid.appendChild(sold[i]);
    }
  }

  /* Insertar tarjetas con animacion escalonada.
     Consciente de la posicion: los disponibles nuevos entran JUSTO ANTES del
     primer agotado ya presente, y los agotados nuevos se anexan al final. Asi
     los agotados existentes nunca se reubican (sin saltos/arrastre al cargar mas). */
  function insertCardsAnimated(grid, cards) {
    var firstSold = grid.querySelector('.sk-collection-grid__card--sold-out');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i].cloneNode(true);
      card.classList.add('sk-collection-grid__card--entering');
      card.style.animationDelay = (i * 30) + 'ms';
      if (card.classList.contains('sk-collection-grid__card--sold-out')) {
        grid.appendChild(card);
      } else if (firstSold) {
        grid.insertBefore(card, firstSold);
      } else {
        grid.appendChild(card);
      }
    }
  }

  /* --- Paginacion simulada en cliente ---
     Todas las cards estan en el DOM (1 sola pagina de servidor) en orden
     disponibles -> agotados. Mostramos un lote y "cargar mas" revela el
     siguiente, de modo que los agotados (al final del DOM) solo aparecen en el
     ultimo lote = "en la ultima pagina". El recorte INICIAL lo hace el CSS
     (sin parpadeo); a partir del 1er click lo controla la clase --paged. */
  function initialVisible() { return window.innerWidth < 768 ? 6 : 20; }
  function revealStep() { return window.innerWidth < 768 ? 12 : 20; }

  /* Cuantas cards quedan ocultas (por recorte CSS inicial o por clase --paged) */
  function hiddenCount(g) {
    if (!g) return 0;
    if (g.classList.contains('sk-collection-grid__grid--mobile-limit') ||
        g.classList.contains('sk-collection-grid__grid--desktop-limit')) {
      var total = g.querySelectorAll('.sk-collection-grid__card').length;
      return Math.max(0, total - initialVisible());
    }
    return g.querySelectorAll('.sk-collection-grid__card--paged').length;
  }

  /* Revela el siguiente lote en cliente. Devuelve true si revelo algo. */
  function revealMore(g) {
    if (!g) return false;
    var cards = g.querySelectorAll('.sk-collection-grid__card');
    var hidden = hiddenCount(g);
    if (!hidden) return false;
    var shown = cards.length - hidden;
    /* Handoff: pasar del recorte por CSS al control por clase --paged */
    g.classList.remove('sk-collection-grid__grid--mobile-limit');
    g.classList.remove('sk-collection-grid__grid--desktop-limit');
    var target = Math.min(shown + revealStep(), cards.length);
    for (var i = 0; i < cards.length; i++) {
      if (i < target) {
        cards[i].classList.remove('sk-collection-grid__card--paged');
      } else {
        cards[i].classList.add('sk-collection-grid__card--paged');
      }
    }
    /* Animar las recien reveladas [shown, target) */
    for (var j = shown; j < target; j++) {
      cards[j].classList.add('sk-collection-grid__card--entering');
      cards[j].style.animationDelay = ((j - shown) * 30) + 'ms';
    }
    return true;
  }

  /* Reinicia la paginacion en cliente al estado inicial (tras filtro/orden) */
  function resetPaging(g) {
    if (!g) return;
    g.classList.add('sk-collection-grid__grid--mobile-limit');
    g.classList.add('sk-collection-grid__grid--desktop-limit');
    var paged = g.querySelectorAll('.sk-collection-grid__card--paged');
    for (var i = 0; i < paged.length; i++) {
      paged[i].classList.remove('sk-collection-grid__card--paged');
    }
  }

  /* Fetch y parsear pagina de coleccion */
  function fetchCollection(url) {
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-grid]');
        var cards = newGrid ? newGrid.querySelectorAll('.sk-collection-grid__card') : [];
        var newBtn = doc.querySelector('[data-load-more-btn]');
        var nextUrl = newBtn ? newBtn.getAttribute('data-next-url') : null;
        var newContainer = doc.querySelector('.sk-collection-grid__container');
        return { cards: cards, nextUrl: nextUrl, newContainer: newContainer };
      });
  }

  /* ---- Bloqueo de altura para evitar layout shift ---- */
  function lockHeight(el) {
    el._skLockedH = el.offsetHeight;
    el.style.minHeight = el._skLockedH + 'px';
  }

  function unlockHeight(el) {
    var lockedH = el._skLockedH || parseInt(el.style.minHeight) || 0;
    if (!lockedH) { el.style.minHeight = ''; return; }

    /* Medir altura natural sin min-height */
    el.style.minHeight = '0';
    var naturalH = el.offsetHeight;
    el.style.minHeight = lockedH + 'px';

    if (Math.abs(lockedH - naturalH) < 2) {
      el.style.minHeight = '';
      delete el._skLockedH;
      return;
    }

    /* Transicionar suavemente a la nueva altura */
    el.offsetHeight; /* forzar reflow para que el browser registre el valor actual */
    el.style.transition = 'min-height 0.35s ease';
    el.style.minHeight = naturalH + 'px';
    setTimeout(function () {
      el.style.transition = '';
      el.style.minHeight = '';
      delete el._skLockedH;
    }, 380);
  }

  /* Contador de generacion: el ultimo click siempre gana */
  var swapGen = 0;

  /*
   * fadeAndSwap: patron centralizado sin flash
   * Cada llamada incrementa swapGen. Si llega otra llamada antes
   * de terminar, la anterior se cancela automaticamente.
   */
  function fadeAndSwap(grid, cont, fetchPromise, onSwap) {
    var gen = ++swapGen;

    lockHeight(cont);
    grid.classList.add('sk-collection-grid__grid--fading');

    var fadeReady = false;
    var fetchResult = null;

    fetchPromise
      .then(function (result) {
        if (gen !== swapGen) return;
        fetchResult = result;
        if (fadeReady) doSwap();
      })
      .catch(function () {
        if (gen !== swapGen) return;
        grid.classList.remove('sk-collection-grid__grid--fading');
        unlockHeight(cont);
      });

    setTimeout(function () {
      if (gen !== swapGen) return;
      fadeReady = true;
      if (fetchResult) doSwap();
    }, 300);

    function doSwap() {
      if (gen !== swapGen) return;

      /* Grid invisible (opacity: 0). Swap contenido. */
      grid.innerHTML = '';
      insertCardsAnimated(grid, fetchResult.cards);
      /* Defensa tras swap completo (detras del fade, sin arrastre visible) */
      sinkSoldOut(grid);
      /* Reiniciar paginacion en cliente: el filtro/orden empieza por el 1er lote */
      resetPaging(grid);

      /* Callback para actualizar load-more, filtros, etc. */
      try { if (onSwap) onSwap(fetchResult); } catch (e) { /* evitar bloqueo */ }

      /* Revelar: quitar fading DESPUES de insertar contenido */
      grid.classList.remove('sk-collection-grid__grid--fading');

      /* Desbloquear altura suavemente tras asentarse las tarjetas */
      setTimeout(function () {
        if (gen !== swapGen) return;
        unlockHeight(cont);
      }, 500);
    }
  }

  function initSection(container) {
    /* R45: guard contra doble inicializacion */
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    var grid = container.querySelector('[data-grid]');
    var loadMoreWrap = container.querySelector('[data-load-more]');
    var loadMoreBtn = container.querySelector('[data-load-more-btn]');
    var cont = container.querySelector('.sk-collection-grid__container');

    /* Defensa: asegurar agotados al final tambien en el render inicial */
    sinkSoldOut(grid);

    /* --- Ordenar --- */
    var sortToggle = container.querySelector('[data-sort-toggle]');
    var sortDropdown = container.querySelector('[data-sort-dropdown]');

    if (sortToggle && sortDropdown) {
      sortToggle.addEventListener('click', function () {
        var isOpen = sortDropdown.classList.contains('sk-collection-grid__sort-dropdown--open');
        closeAllDropdowns(container);
        if (!isOpen) {
          sortDropdown.classList.add('sk-collection-grid__sort-dropdown--open');
          sortToggle.setAttribute('aria-expanded', 'true');
        }
      });

      var sortOptions = sortDropdown.querySelectorAll('[data-sort-value]');
      for (var s = 0; s < sortOptions.length; s++) {
        sortOptions[s].addEventListener('click', function () {
          var value = this.getAttribute('data-sort-value');
          closeAllDropdowns(container);
          applyFiltersAndSort(container, value);
        });
      }
    }

    /* --- Filtrar --- */
    var filterToggle = container.querySelector('[data-filter-toggle]');
    var filterPanel = container.querySelector('[data-filter-panel]');

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var isOpen = filterPanel.classList.contains('sk-collection-grid__filter-panel--open');
        closeAllDropdowns(container);
        if (!isOpen) {
          filterPanel.classList.add('sk-collection-grid__filter-panel--open');
          filterToggle.setAttribute('aria-expanded', 'true');
        }
      });

      var applyBtn = filterPanel.querySelector('[data-filter-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          closeAllDropdowns(container);
          applyFiltersAndSort(container, null);
        });
      }

      var clearBtn = filterPanel.querySelector('[data-filter-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          closeAllDropdowns(container);
          applyFiltersAndSort(container, null, true);
        });
      }
    }

    /* Cerrar dropdowns al hacer click fuera */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sort-wrap]') && !e.target.closest('[data-filter-wrap]')) {
        closeAllDropdowns(container);
      }
    });

    function closeAllDropdowns(ctx) {
      var dd = ctx.querySelector('[data-sort-dropdown]');
      var fp = ctx.querySelector('[data-filter-panel]');
      var st = ctx.querySelector('[data-sort-toggle]');
      var ft = ctx.querySelector('[data-filter-toggle]');
      if (dd) dd.classList.remove('sk-collection-grid__sort-dropdown--open');
      if (fp) fp.classList.remove('sk-collection-grid__filter-panel--open');
      if (st) st.setAttribute('aria-expanded', 'false');
      if (ft) ft.setAttribute('aria-expanded', 'false');
    }

    /* --- Filtros + Sort via AJAX --- */
    function applyFiltersAndSort(ctx, sortValue, clearAll) {
      var baseUrl = ctx.closest('.sk-collection-grid').getAttribute('data-collection-url') || window.location.pathname;
      var params = [];

      if (clearAll) {
        var currentSort = ctx.querySelector('.sk-collection-grid__sort-option--active');
        if (currentSort && !sortValue) {
          sortValue = currentSort.getAttribute('data-sort-value');
        }
      } else {
        var checkboxes = ctx.querySelectorAll('[data-filter-input]:checked');
        for (var c = 0; c < checkboxes.length; c++) {
          params.push(encodeURIComponent(checkboxes[c].name) + '=' + encodeURIComponent(checkboxes[c].value));
        }
        var priceInputs = ctx.querySelectorAll('input[type="number"][data-filter-input]');
        for (var pi = 0; pi < priceInputs.length; pi++) {
          if (priceInputs[pi].value) {
            params.push(encodeURIComponent(priceInputs[pi].name) + '=' + encodeURIComponent(priceInputs[pi].value));
          }
        }
      }

      if (sortValue) {
        params.push('sort_by=' + encodeURIComponent(sortValue));
      } else {
        var activeSort = ctx.querySelector('.sk-collection-grid__sort-option--active');
        if (activeSort) {
          params.push('sort_by=' + encodeURIComponent(activeSort.getAttribute('data-sort-value')));
        }
      }

      var url = baseUrl + (params.length ? '?' + params.join('&') : '');

      fadeAndSwap(grid, cont, fetchCollection(url), function (result) {
        var nc = result.newContainer;
        if (!nc) return;

        /* Reemplazar load-more */
        var lmWrap = ctx.querySelector('[data-load-more]');
        var newLm = nc.querySelector('[data-load-more]');
        if (lmWrap && newLm) {
          lmWrap.outerHTML = newLm.outerHTML;
        } else if (lmWrap && !newLm) {
          lmWrap.style.display = 'none';
        } else if (!lmWrap && newLm) {
          ctx.querySelector('[data-grid]').insertAdjacentHTML('afterend', newLm.outerHTML);
        }

        /* Reemplazar panel de filtros */
        var newFP = nc.querySelector('[data-filter-panel]');
        var curFP = ctx.querySelector('[data-filter-panel]');
        if (newFP && curFP) curFP.innerHTML = newFP.innerHTML;

        /* Badge */
        var newBadge = nc.querySelector('.sk-collection-grid__filter-badge');
        var curBadge = ctx.querySelector('.sk-collection-grid__filter-badge');
        var fBtn = ctx.querySelector('[data-filter-toggle]');
        if (curBadge) curBadge.remove();
        if (newBadge && fBtn) fBtn.appendChild(newBadge.cloneNode(true));

        /* Sort: refrescar el desplegable (check de la opcion activa) */
        var newSortDd = nc.querySelector('[data-sort-dropdown]');
        var curSortDd = ctx.querySelector('[data-sort-dropdown]');
        if (newSortDd && curSortDd) curSortDd.innerHTML = newSortDd.innerHTML;

        /* Conteo */
        var newCount = nc.querySelector('.sk-collection-grid__count');
        var curCount = ctx.querySelector('.sk-collection-grid__count');
        if (newCount && curCount) curCount.textContent = newCount.textContent;

        window.history.pushState({}, '', url);
        rebindLoadMore(ctx);
        rebindSortOptions(ctx);
        rebindFilterActions(ctx);
      });
    }

    /* (revealMobileHidden eliminada: ahora la paginacion la maneja revealMore
       a nivel de modulo, igual en mobile y desktop) */

    /* Re-bind boton cargar mas despues de AJAX */
    function rebindLoadMore(ctx) {
      var btn = ctx.querySelector('[data-load-more-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var g = ctx.querySelector('[data-grid]');
        /* 1) Revelar el siguiente lote en cliente (paginacion simulada) */
        if (revealMore(g)) {
          var nu = btn.getAttribute('data-next-url');
          if (hiddenCount(g) === 0 && !nu) {
            var w = ctx.querySelector('[data-load-more]');
            if (w) w.style.display = 'none';
          }
          return;
        }

        /* 2) Nada que revelar en DOM -> pagina de servidor (colecciones >48) */
        var nextUrl = btn.getAttribute('data-next-url');
        if (!nextUrl) {
          var wrap = ctx.querySelector('[data-load-more]');
          if (wrap) wrap.style.display = 'none';
          return;
        }
        btn.classList.add('sk-collection-grid__load-more-btn--loading');

        fetchCollection(nextUrl)
          .then(function (result) {
            var g = ctx.querySelector('[data-grid]');
            var c = ctx.querySelector('.sk-collection-grid__container');
            var oldH = c.offsetHeight;
            c.style.overflow = 'hidden';
            c.style.maxHeight = oldH + 'px';

            insertCardsAnimated(g, result.cards);
            if (result.nextUrl) {
              btn.setAttribute('data-next-url', result.nextUrl);
            } else {
              var wrap = ctx.querySelector('[data-load-more]');
              if (wrap) wrap.style.display = 'none';
            }
            btn.classList.remove('sk-collection-grid__load-more-btn--loading');

            c.style.maxHeight = 'none';
            var newH = c.scrollHeight;
            c.style.maxHeight = oldH + 'px';
            c.offsetHeight;

            c.style.transition = 'max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
            c.style.maxHeight = newH + 'px';
            setTimeout(function () {
              c.style.transition = '';
              c.style.maxHeight = '';
              c.style.overflow = '';
            }, 550);
          })
          .catch(function () {
            btn.classList.remove('sk-collection-grid__load-more-btn--loading');
          });
      });
    }

    /* Re-bind opciones de sort */
    function rebindSortOptions(ctx) {
      var opts = ctx.querySelectorAll('[data-sort-value]');
      for (var s = 0; s < opts.length; s++) {
        opts[s].addEventListener('click', function () {
          var value = this.getAttribute('data-sort-value');
          closeAllDropdowns(ctx);
          applyFiltersAndSort(ctx, value);
        });
      }
    }

    /* Re-bind acciones del panel de filtros (Aplicar / Borrar) tras swap AJAX.
       El innerHTML del panel se reemplaza, asi que hay que volver a vincular. */
    function rebindFilterActions(ctx) {
      var applyBtn = ctx.querySelector('[data-filter-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          closeAllDropdowns(ctx);
          applyFiltersAndSort(ctx, null);
        });
      }
      var clearBtn = ctx.querySelector('[data-filter-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          closeAllDropdowns(ctx);
          applyFiltersAndSort(ctx, null, true);
        });
      }
    }

    /* --- Drag to scroll en pills --- */
    var pillsNav = container.querySelector('[data-pills]');
    if (pillsNav) {
      var pillDown = false;
      var pillStartX = 0;
      var pillScrollL = 0;
      var pillDragged = false;

      pillsNav.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        pillDown = true;
        pillDragged = false;
        pillStartX = e.pageX - pillsNav.offsetLeft;
        pillScrollL = pillsNav.scrollLeft;
        pillsNav.style.cursor = 'grabbing';
      });

      pillsNav.addEventListener('mouseleave', function () {
        pillDown = false;
        pillsNav.style.cursor = '';
      });

      pillsNav.addEventListener('mouseup', function () {
        pillDown = false;
        pillsNav.style.cursor = '';
      });

      pillsNav.addEventListener('mousemove', function (e) {
        if (!pillDown) return;
        e.preventDefault();
        pillDragged = true;
        var x = e.pageX - pillsNav.offsetLeft;
        pillsNav.scrollLeft = pillScrollL - (x - pillStartX);
      });

      /* Evitar click en pill tras drag */
      pillsNav.addEventListener('click', function (e) {
        if (pillDragged) {
          e.preventDefault();
          e.stopPropagation();
          pillDragged = false;
        }
      }, true);
    }

    /* --- Filtrado por subcategorias via AJAX --- */
    var pills = container.querySelectorAll('[data-filter-pill]');
    if (pills.length && grid) {
      for (var p = 0; p < pills.length; p++) {
        pills[p].addEventListener('click', function () {
          var pill = this;
          var filterUrl = pill.getAttribute('data-filter-url');
          if (!filterUrl) return;

          /* Marcar pill activo */
          for (var j = 0; j < pills.length; j++) {
            pills[j].classList.remove('sk-collection-grid__pill--active');
          }
          pill.classList.add('sk-collection-grid__pill--active');

          fadeAndSwap(grid, cont, fetchCollection(filterUrl), function (result) {
            /* Actualizar boton cargar mas */
            var lmWrap = container.querySelector('[data-load-more]');
            var lmBtn = container.querySelector('[data-load-more-btn]');
            if (result.nextUrl && lmBtn && lmWrap) {
              lmBtn.setAttribute('data-next-url', result.nextUrl);
              lmWrap.style.display = '';
            } else if (lmWrap) {
              lmWrap.style.display = 'none';
            }
          });
        });
      }
    }

    /* --- Cargar mas productos via AJAX --- */
    if (loadMoreBtn && grid) {
      loadMoreBtn.addEventListener('click', function () {
        /* 1) Revelar el siguiente lote en cliente (paginacion simulada) */
        if (revealMore(grid)) {
          var nu = loadMoreBtn.getAttribute('data-next-url');
          if (hiddenCount(grid) === 0 && !nu) {
            if (loadMoreWrap) loadMoreWrap.style.display = 'none';
          }
          return;
        }

        /* 2) Nada que revelar en DOM -> pagina de servidor (colecciones >48) */
        var nextUrl = loadMoreBtn.getAttribute('data-next-url');
        if (!nextUrl) {
          if (loadMoreWrap) loadMoreWrap.style.display = 'none';
          return;
        }

        loadMoreBtn.classList.add('sk-collection-grid__load-more-btn--loading');

        fetchCollection(nextUrl)
          .then(function (result) {
            /* Capturar altura actual y fijarla como max-height */
            var oldH = cont.offsetHeight;
            cont.style.overflow = 'hidden';
            cont.style.maxHeight = oldH + 'px';

            insertCardsAnimated(grid, result.cards);

            if (result.nextUrl) {
              loadMoreBtn.setAttribute('data-next-url', result.nextUrl);
            } else {
              if (loadMoreWrap) loadMoreWrap.style.display = 'none';
            }

            loadMoreBtn.classList.remove('sk-collection-grid__load-more-btn--loading');

            /* Medir nueva altura real (sin restriccion) */
            cont.style.maxHeight = 'none';
            var newH = cont.scrollHeight;
            /* Volver a la vieja para animar */
            cont.style.maxHeight = oldH + 'px';
            cont.offsetHeight; /* forzar reflow */

            cont.style.transition = 'max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
            cont.style.maxHeight = newH + 'px';
            setTimeout(function () {
              cont.style.transition = '';
              cont.style.maxHeight = '';
              cont.style.overflow = '';
            }, 550);
          })
          .catch(function () {
            loadMoreBtn.classList.remove('sk-collection-grid__load-more-btn--loading');
          });
      });
    }

    /* --- Mini-galeria: pasar las imagenes de la card con las flechas --- */
    container.addEventListener('click', function (e) {
      var arrow = e.target.closest('.sk-collection-grid__img-arrow');
      if (!arrow) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = arrow.closest('.sk-collection-grid__image-wrapper');
      if (!wrapper) return;

      var imgs = wrapper.querySelectorAll('.sk-collection-grid__image');
      if (imgs.length < 2) return;

      var current = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('sk-collection-grid__image--active')) { current = i; break; }
      }

      var dir = arrow.classList.contains('sk-collection-grid__img-arrow--next') ? 1 : -1;
      var next = (current + dir + imgs.length) % imgs.length;

      imgs[current].classList.remove('sk-collection-grid__image--active');
      imgs[next].classList.add('sk-collection-grid__image--active');

      /* La flecha izquierda solo aparece si no estamos en la primera imagen */
      var prevBtn = wrapper.querySelector('.sk-collection-grid__img-arrow--prev');
      if (prevBtn) prevBtn.classList.toggle('sk-collection-grid__img-arrow--hidden', next === 0);
    });

    /* --- Anadir al carrito --- */
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.sk-collection-grid__action-btn--cart');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      if (btn.classList.contains('sk-collection-grid__action-btn--loading')) return;
      btn.classList.add('sk-collection-grid__action-btn--loading');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      /* Pedir sections del drawer para que la respuesta incluya el HTML re-renderizado */
      var cartItemsComp = document.querySelector('cart-items-component[data-section-id]');
      var sectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
      if (sectionId) formData.append('sections', sectionId);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.classList.remove('sk-collection-grid__action-btn--loading');

          if (data.status) return;

          btn.classList.add('sk-collection-grid__action-btn--added');
          setTimeout(function () {
            btn.classList.remove('sk-collection-grid__action-btn--added');
          }, 1500);

          /* Actualizar contador + dispatch cart:update con sections reales + abrir drawer */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count]');
            for (var c = 0; c < counters.length; c++) counters[c].textContent = cart.item_count;

            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, data: { sections: data.sections || {}, itemCount: cart.item_count } },
            }));

            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && drawer.showDialog) drawer.showDialog();
          });
        })
        .catch(function () {
          btn.classList.remove('sk-collection-grid__action-btn--loading');
        });
    });
  }

  /* R44: querySelectorAll para multiples instancias */
  var sections = document.querySelectorAll('.sk-collection-grid');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sk-collection-grid');
    if (section) initSection(section);
  });
})();
